import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
  signal,
} from '@angular/core';

export interface MenuItem {
  label: string;
  value?: string;
  disabled?: boolean;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-menu',
  styleUrl: './menu.scss',
  templateUrl: './menu.html',
})
export class MenuComponent {
  /** Libellé du bouton déclencheur. */
  readonly label = input('Menu');

  /** Éléments du menu (mode déclaratif). */
  readonly items = input<MenuItem[]>([]);

  /** Émis lorsqu'un élément du menu est sélectionné. */
  readonly selected = output<MenuItem>();

  protected readonly open = signal(false);

  private readonly elementRef = inject(ElementRef);

  protected toggle(): void {
    this.open.update((value) => !value);
  }

  protected select(item: MenuItem): void {
    if (item.disabled) {
      return;
    }
    this.open.set(false);
    this.selected.emit(item);
  }

  @HostListener('document:click', ['$event'])
  protected onDocumentClick(event: MouseEvent): void {
    const host = this.elementRef.nativeElement as HTMLElement;
    if (!host.contains(event.target as Node)) {
      this.open.set(false);
    }
  }
}
